import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    SHIPMENTACTIVITIES_FEATURE_KEY,
    State,
    ShipmentActivitiesPartialState,
    shipmentActivitiesAdapter,
} from './shipment-activities.reducer';

// Lookup the 'ShipmentActivities' feature state managed by NgRx
export const getShipmentActivitiesState = createFeatureSelector<
    ShipmentActivitiesPartialState,
    State
>(SHIPMENTACTIVITIES_FEATURE_KEY);

const { selectAll, selectEntities } = shipmentActivitiesAdapter.getSelectors();

export const getShipmentActivitiesLoading = createSelector(
    getShipmentActivitiesState,
    (state: State) => state.loading
);

export const getShipmentActivitiesError = createSelector(
    getShipmentActivitiesState,
    (state: State) => state.error
);

export const getShipmentActivitiesPagination = createSelector(
    getShipmentActivitiesState,
    (state: State) => state.pagination
);

export const getAllShipmentActivities = createSelector(
    getShipmentActivitiesState,
    (state: State) => selectAll(state)
);

export const getShipmentActivitiesEntities = createSelector(
    getShipmentActivitiesState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getShipmentActivitiesState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getShipmentActivitiesEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);
